// frontend/src/components/integrations/CustomMcpServerCard.tsx
import { Server } from "lucide-react";
import React from "react";
import { Card } from "src/components/ui/card";

interface CustomMcpServerCardProps {
  name: string;
  description?: string | null;
  isActive?: boolean;
  actionLabel?: string;
  statusLabel?: string;
  onClick: () => void;
}

export default function CustomMcpServerCard({
  name,
  description,
  isActive,
  actionLabel = "Manage",
  statusLabel,
  onClick,
}: CustomMcpServerCardProps) {
  const renderStatus = () => {
    if (statusLabel !== undefined) {
      return (
        <div className="flex items-center text-xs mt-1 text-muted-foreground">
          <div className="w-1.5 h-1.5 rounded-full mr-1.5 bg-neutral-400" />
          {statusLabel}
        </div>
      );
    }
    if (isActive === undefined) return null;
    return (
      <div className={`flex items-center text-xs mt-1 ${isActive ? "text-green-500" : "text-yellow-500"}`}>
        <div className={`w-1.5 h-1.5 rounded-full mr-1.5 ${isActive ? "bg-green-500" : "bg-yellow-500"}`} />
        {isActive ? "Connected" : "Inactive"}
      </div>
    );
  };

  return (
    <Card interactive onClick={onClick} className="p-5 bg-transparent">
      <div className="flex items-center space-x-4 mb-4">
        <div className="flex-shrink-0 h-8 w-8 rounded-md bg-muted flex items-center justify-center">
          <Server className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="flex-grow min-w-0">
          <h3 className="font-medium text-foreground truncate">{name}</h3>
          {renderStatus()}
        </div>
      </div>
      {description && (
        <p className="text-xs text-muted-foreground pl-12 mb-3 line-clamp-2">{description}</p>
      )}
      <span className="text-sm font-medium pl-12 text-muted-foreground hover:text-foreground transition-colors">
        {actionLabel}
      </span>
    </Card>
  );
}
